require("./arrow.svg");
require("./menu.svg");
require("./menu_close.svg");
require("./menu_arrow.svg");
require("./menu_arrow-mobile.svg");
require("./menu_back.svg");
require("./home.svg");
require("./close.svg");
require("./play_circle.svg");
require("./download.svg");

require("./facebook.svg");
require("./twitter.svg");
require("./youtube.svg");
require("./instagram.svg");
require("./linkedin.svg");

require("./calender.svg");
require("./chair.svg");
require("./clock.svg");
require("./locatie.svg");
require("./max.svg");
require("./parking.svg");
require("./euro.svg");
require("./discount.svg");
require("./group.svg");
